import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShield2"><Path fillRule="evenodd" clipRule="evenodd" d="M11.0481 1.85127C11.6579 1.6002 12.3421 1.6002 12.9519 1.85127L19.4519 4.52774C20.3886 4.91346 21 5.82638 21 6.83943V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V6.83943C3 5.82638 3.61137 4.91346 4.54813 4.52774L11.0481 1.85127Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield2;
